module.exports = __webpack_public_path__ + "img/personnel_access_feature_04.ed430ec5.jpg";